<template>
  <v-card flat tile class="body-2"
          colorss="grey lighten-3"
          v-bind:class="'substatus-'+subscription.statusId"
  >
    <v-container grid-list-md fluid>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6 md4>
          <div>Аб. №{{ userSubscriptionId }}</div>
          <collapsible-bar
            class="caption flex"
            :rows="assignedClasses"
            :each-row-on-new-line="true"
          ></collapsible-bar>
          <collapsible-bar
            v-if="subscription.Subscription.family"
            class="caption flex"
            :rows="familyMembers"
            :include-commas="true"
          ></collapsible-bar>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <div>
            <span v-if="subscription.visitCount">
            Ост. <span
              v-bind:class="visitsClass"
            >{{ visitsLeft }}</span>/{{subscription.visitCount}} зан.
            </span>
            <span v-if="beginDate"> c {{ beginDate }}</span>
            <span v-if="endDate"> по {{ endDate }}</span>
          </div>
          <div v-if="subscription.statTotalBurned" class="caption">
            Сгорело: <span class="red--text">{{ subscription.statTotalBurned }}</span> зан.
          </div>
        </v-flex>
        <v-flex xs12 md3 :class="{
          'grey--text': subscription.Subscription.family
          && subscription.userId !== currentUserId,
        }">
          <div>
            Внесено <span :class="{
              'green--text': !subscription.Subscription.family
                || subscription.userId === currentUserId,
               'grey--text': subscription.Subscription.family
                && subscription.userId !== currentUserId,
            }">{{ subscription.payed.toLocaleString(lang) }}
            </span> /
            <money :sum="remain" :color-class="{
              'red--text': !subscription.Subscription.family
                || subscription.userId === currentUserId,
               'grey--text': subscription.Subscription.family
                && subscription.userId !== currentUserId,
            }"></money>
          </div>
          <div v-if="!subscription.Subscription.family || subscription.userId === currentUserId">
            <div v-for="item of debtInvoices" :key="item.id">
              <span :class="item.color" class="caption"> Долг
                <money color-class="red--text" :sum="item.debt"></money>
                до {{ item.payDate }}
              </span>
            </div>
          </div>
          <div v-if="isShowCreatePaymentButton">
            <v-btn text color="accent" class="pl-0"
                   @click="showPaymentPanel('invoice', debtInvoices[0].id)">
              + Платеж
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12 md2 class="text-left text-md-center">
          <div v-bind:class="statusClass">{{ status }}</div>
          <div v-if="freezePeriod" class="caption">
            <span v-if="subscription.statusId!==3"> Будет зам.</span>
            {{ freezePeriod }}
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import { getClassName } from '@/lib/classHelpers';
import { STATUS } from '@/lib/subscriptionHelpers';
import Money from '@/components/Money.vue';
import CollapsibleBar from '@/components/CollapsibleBar.vue';

export default {
  name: 'UserSubscriptionCard',
  components: { Money, CollapsibleBar },
  props: ['subscription'],
  computed: {
    userSubscriptionId() {
      if (this.subscription.externalId
        && this.$store.state.UISettings.userSubscriptionExternalIdIncluded) {
        const { externalId } = this.subscription;
        return externalId.length > 6 ? `${externalId.slice(0, 6)}...` : externalId;
      }
      return this.subscription.id;
    },
    assignedClasses() {
      const classes = [...this.subscription.classIds.map(id => getClassName(id))];
      if (this.isMulti) classes.unshift(`Мульти ${classes.shift()}`);
      return classes;
    },
    currentUserId() {
      const { currentUserId: userId } = this.$store.state;
      return userId;
    },
    familyMembers() {
      const { currentUserId: userId } = this.$store.state;
      const { userId: ownerUserId } = this.subscription;
      return [...(this.$store.state.account.families[userId] || [])]
        .sort(({ userId: id }) => (id === ownerUserId && -1) || 1)
        .map(({ name }, index) => (index && name) || `${name} (Осн)`);
    },
    visitsLeft() {
      return this.subscription.visitCount - this.subscription.statTotalBurned
        - this.subscription.visitedCount;
    },
    remain() {
      return this.subscription.price - this.subscription.payed;
    },
    visitsClass() {
      return this.visitsLeft > 0 ? 'green--text' : 'red--text';
    },
    statusClass() {
      return this.subscription.statusId === 2 ? 'primary--text' : 'red--text';
    },
    beginDate() {
      return this.subscription.beginDate ? moment(this.subscription.beginDate).format('DD.MM') : null;
    },
    endDate() {
      return this.subscription.endDate ? moment(this.subscription.endDate).format('DD.MM') : null;
    },
    status() {
      return STATUS[this.subscription.statusId];
    },
    debtInvoices() {
      if (this.subscription.invoices) {
        return this.subscription.invoices
          .filter(invoice => invoice.price > invoice.payed)
          .map(invoice => ({
            color: this.getDebtColor(invoice.payUntil),
            payDate: moment(invoice.payUntil).format('DD.MM'),
            debt: invoice.price - invoice.payed - invoice.payedBonuses,
            ...invoice,
          }));
      }
      return [];
    },
    debtDate() {
      const { remindDate } = this.subscription;
      return remindDate ? moment(remindDate).format('DD.MM') : null;
    },
    freezePeriod() {
      const { freezeFrom, freezeTo } = this.subscription;
      if (freezeFrom) {
        return `с ${moment(freezeFrom).format('DD.MM')} по ${moment(freezeTo).format('DD.MM')}`;
      }
      return null;
    },
    isMulti() {
      if (!this.subscription.Subscription.id) {
        return false;
      }
      const subType = this.subscriptionTypes
        .find(el => el.id === this.subscription.Subscription.id);
      if (!subType) return false;
      return subType.isMulti;
    },
    isShowCreatePaymentButton() {
      const { currentUserId } = this.$store.state;

      if (this.subscription.Subscription.family
        && this.subscription.userId !== currentUserId) {
        return false;
      }

      if (!this.debtInvoices.length
        || !this.allowOnlinePayment) {
        return false;
      }

      const cl = this.allowedClassIds.find(id => id === this.subscription.mainClassId);
      if (!cl) {
        return false;
      }

      return true;
    },
    ...mapGetters(['allowOnlinePayment', 'lang', 'allowedClassIds', 'subscriptionTypes']),
  },
  methods: {
    getDebtColor(date) {
      if (!date) {
        return null;
      }
      const diff = -moment().diff(date, 'day');
      if (diff < 0) {
        return 'red lighten-4';
      }
      if (diff < 3) {
        return 'orange lighten-4';
      }
      return 'light-blue lighten-4';
    },
    showPaymentPanel(payFor, payObjectId) {
      this.setCreatePaymentDialog({
        payFor,
        payObjectId,
      });
    },
    ...mapMutations(['setCreatePaymentDialog']),
  },
};
</script>

<style scoped>

  .substatus-4 {
    background-color: rgb(252, 235, 235);
  }

  .substatus-2 {
    background-color: rgb(237, 247, 237);
  }


</style>
